import { Button, Grid, IconButton, Tooltip } from "@material-ui/core";
import { Fragment, useEffect } from "react";
import { inputColor, inputVariant } from "../../../../settings/inputConfig";

import AddIcon from "@material-ui/icons/Add";
import BlockIcon from "@material-ui/icons/Block";
import CancelarConsulta from "./CancelarConsulta";
import { DatePicker } from "@material-ui/pickers";
import EditIcon from "@material-ui/icons/Edit";
import FormConsulta from "./FormConsulta";
import HelperConsulta from "./HelperConsulta";
import MeditocActions from "../../../utils/MeditocActions";
import MeditocBody from "../../../utils/MeditocBody";
import MeditocDateIcon from "../../../utils/MeditocDateIcon";
import MeditocHeader from "../../../utils/MeditocHeader";
import MeditocTable from "../../../utils/MeditocTable";
import RefreshIcon from "@material-ui/icons/Refresh";
import { fnEmpty } from "../../../../settings/preventConfig";
import { getAdminConsultaColumns } from "../../../../models/AdminConsultaModel";
import { useAdminConsulta } from "../../../../context/AdminConsultaContext";
import { useLogin } from "../../../../context/LoginContext";

export default function AdminConsulta() {
    const { usuarioPermisos } = useLogin();
    const {
        usuarioColaborador,
        listaConsultas,
        consultaSeleccionada,
        formFiltroConsulta,
        handleChangeConsultaSeleccionada,
        handleChangeFormFiltroConsultaDate,
        handleChangeFormFiltroConsultaDateDe,
        handleClickNuevaConsulta,
        handleClickEditarConsulta,
        handleClickCancelarConsulta,
        handleClickRefrescarDatos,
        handleClickLimpiarFiltro,
        handleClickStartAdminConsulta,
    } = useAdminConsulta();

    const permisos = usuarioPermisos["4"].Submodulos["2"];
    const { txtFechaDe, txtFechaA } = formFiltroConsulta;

    useEffect(() => {
        handleClickStartAdminConsulta();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (usuarioColaborador) {
            handleClickRefrescarDatos();
        }
        // eslint-disable-next-line
    }, [usuarioColaborador]);

    return (
        <Fragment>
            <MeditocHeader title={permisos.Nombre}>
                {permisos.Botones["1"] && ( //Nueva consulta
                    <Tooltip title={permisos.Botones["1"].Nombre} arrow>
                        <span>
                            <IconButton onClick={handleClickNuevaConsulta} disabled={!usuarioColaborador}>
                                <AddIcon className="color-0" />
                            </IconButton>
                        </span>
                    </Tooltip>
                )}
                {permisos.Botones["2"] && ( //Reprogramar consulta
                    <Tooltip title={permisos.Botones["2"].Nombre} arrow>
                        <span>
                            <IconButton onClick={handleClickEditarConsulta} disabled={!usuarioColaborador}>
                                <EditIcon className="color-0" />
                            </IconButton>
                        </span>
                    </Tooltip>
                )}
                {permisos.Botones["3"] && ( //Cancelar consulta
                    <Tooltip title={permisos.Botones["3"].Nombre} arrow>
                        <span>
                            <IconButton onClick={handleClickCancelarConsulta} disabled={!usuarioColaborador}>
                                <BlockIcon className="color-0" />
                            </IconButton>
                        </span>
                    </Tooltip>
                )}
                {permisos.Botones["4"] && ( //Actualizar tabla
                    <Tooltip title={permisos.Botones["4"].Nombre} arrow>
                        <span>
                            <IconButton onClick={handleClickRefrescarDatos} disabled={!usuarioColaborador}>
                                <RefreshIcon className="color-0" />
                            </IconButton>
                        </span>
                    </Tooltip>
                )}
            </MeditocHeader>
            <MeditocBody>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <MeditocActions title="Fechas de consultas" />
                    </Grid>
                    <Grid item sm={6} xs={12}>
                        <DatePicker
                            name="txtFechaDe"
                            label={txtFechaDe.label}
                            value={txtFechaDe.value}
                            onChange={handleChangeFormFiltroConsultaDateDe}
                            InputProps={{ endAdornment: <MeditocDateIcon /> }}
                            disabled={!usuarioColaborador}
                            inputVariant={inputVariant}
                            maxDate={txtFechaA.value}
                            format="dd/MM/yyyy"
                            color={inputColor}
                            variant="inline"
                            fullWidth
                            autoOk={true}
                        />
                    </Grid>
                    <Grid item sm={6} xs={12}>
                        <DatePicker
                            name="txtFechaA"
                            label={txtFechaA.label}
                            value={txtFechaA.value}
                            onChange={(date) => handleChangeFormFiltroConsultaDate(date, "txtFechaA")}
                            InputProps={{ endAdornment: <MeditocDateIcon /> }}
                            disabled={!usuarioColaborador}
                            inputVariant={inputVariant}
                            minDate={txtFechaDe.value}
                            format="dd/MM/yyyy"
                            color={inputColor}
                            variant="inline"
                            fullWidth
                            autoOk={true}
                        />
                    </Grid>
                    <Grid item xs={12} className="right">
                        <Button
                            variant="contained"
                            style={{ color: "#555", marginRight: "10px" }}
                            onClick={handleClickLimpiarFiltro}
                            disabled={!usuarioColaborador}
                        >
                            LIMIPIAR
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleClickRefrescarDatos}
                            disabled={!usuarioColaborador}
                        >
                            FILTRAR
                        </Button>
                    </Grid>
                    <Grid item xs={12}>
                        <MeditocTable
                            id="iIdConsulta"
                            data={listaConsultas}
                            row={consultaSeleccionada}
                            columns={getAdminConsultaColumns()}
                            setRow={handleChangeConsultaSeleccionada}
                            fnDoubleClick={permisos.Botones["2"] ? handleClickEditarConsulta : fnEmpty}
                        />
                    </Grid>
                </Grid>
            </MeditocBody>
            <HelperConsulta />
            <FormConsulta />
            <CancelarConsulta />
        </Fragment>
    );
}
